import PropTypes from 'prop-types';
import Link from 'next/link'
import Breadcrumb from './Breadcrumb';
import { getSimpleRole, getRoleUrl } from '../../data/getRole';
import Breadcrumbs from './Breadcrumbs';
import { getNewUrlType } from '../../utils/urlHelpers';
import BreadcrumbSeparator from './BreadcrumbSeparator';

const propTypes = {
    handleCityChange: PropTypes.func,
};

const defaultProps = {
    handleCityChange: () => {},
};

const BreadcrumbsSearchPage = ({
    vertical_id,
    professionalName,
    city,
    town,
    showMe,
}) => {
    const role = getSimpleRole(vertical_id);
    const urlPath = getRoleUrl(vertical_id);
    const cityIsTown = (city === town) && (city || town);
    const hasCity = !cityIsTown && Boolean(city);
    const hasTown = !cityIsTown && Boolean(town);

    return (
        <Breadcrumbs>
            <li>
                <Link href={getNewUrlType(urlPath)}>
                    <a className='no-underline'>{ role }</a>
                </Link>

                <BreadcrumbSeparator />
            </li>
            
            {cityIsTown &&
                <Breadcrumb
                    url={`${urlPath}/${city.toLowerCase()}`}
                    value={city}
                    highlight={city && !town && !professionalName}
                />
            }

            {hasCity &&
                <Breadcrumb
                    url={hasTown ? `${urlPath}/${city.toLowerCase()}` + (showMe === 'firms' ? ('?view=' + showMe) : '') : null}
                    value={city}
                    highlight={city && !town && !professionalName}
                />
            }

            {hasTown &&
                <Breadcrumb
                    value={town}
                    highlight={city && town && !professionalName}
                />
            }
        </Breadcrumbs>
    );
};

BreadcrumbsSearchPage.defaultProps = defaultProps;
BreadcrumbsSearchPage.propTypes = propTypes;

export default BreadcrumbsSearchPage;
